import {apiConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';

const {__HERMES__} = apiConfig;
export default function getDetailsPageHermesAPIUrl(
  config,
  // cityId = '',
  // vhid,
  // retry = true,
  // sendGAData = false,
) {
  const {
    vhid,
    cityId,
    checkin,
    checkout,
    roomString,
    pricingData,
    staticData,
    selectedHotelStatic,
    searchQuery,
    channel,
    pc = '',
    filter,
    offerCodeFromQueryParam,
    apiVersion,
    flavor,
  } = config;
  if (!vhid || !cityId) {
    return '';
  }

  const hotelId = vhid;
  const {ibp = '', hmd = ''} = selectedHotelStatic;
  const {hctx = '', sctx = ''} = filter;
  const context = hctx ? `&hctx=${hctx}` : '';
  const subContext = sctx && sctx.length ? `&sctx=${sctx}` : '';
  const offerCode = offerCodeFromQueryParam ? `&pc=${offerCodeFromQueryParam}` : '';
  const targetPricingData = pricingData ? pricingData[hotelId] : {};
  const {updatedAt, loaded} = targetPricingData;
  // check if data from SRP is there, else take the store pc value
  // const pc = selectedHotelStatic && Object.keys(selectedHotelStatic).length ? selectedHotelStatic.pc : hotels.pc;

  let vcid = cityId;
  if (!vcid && searchQuery !== null && searchQuery.ct && searchQuery.ct._id) {
    vcid = searchQuery.ct._id;
  } else if (
    !vcid &&
    staticData &&
    staticData[hotelId] &&
    staticData[hotelId].data &&
    staticData[hotelId].data.vcid
  ) {
    vcid = staticData[hotelId].data.vcid;
  }

  const obj = {};
  obj[hotelId] = {
    loaded: false,
  };
  if (updatedAt && loaded && new Date(updatedAt) > new Date() - 10 * 60 * 1000) {
    obj[hotelId] = targetPricingData;
  }
  // const authId = user.header['OAUTH-GOIBIBO'] || '';
  const ci = parseDateIntoHermesString(checkin.date);
  const co = parseDateIntoHermesString(checkout.date);
  const isHmd = hmd ? `&hmd=${hmd}` : '';
  // const filteredPaymodes = [1];
  // const pmFilter = filteredPaymodes ? `&pm=${filteredPaymodes}` : '';
  const pricingVersion = `/hotels/${apiVersion}/detail/price/${flavor}`;

  const hermesUrl = `${__HERMES__}${pricingVersion}/${vcid}/${ci}/${co}/${roomString}/${hotelId}?${
    ibp ? `&ibp=${ibp}` : ''
  }&tmz=${checkin.date.getTimezoneOffset()}${context}${subContext}${
    channel ? `&tags=["${channel}"]` : ''
  }${isHmd}${offerCode}`;
  return hermesUrl;
  // console.info(hermesUrl);

  // let respJson = {};
  // try {
  //   // const headers = new Headers(header);
  //   // const request = new Request(hermesUrl, {headers});
  //   // const response = await fetch(request, {credentials: 'include'});
  //   // respJson = await response.json();
  //   // console.info(respJson);
  // } catch (err) {
  //   console.trace(err);
  //   if (retry) {
  //     pricingDataCall({vcid, hotelId, retry: false});
  //   } else {
  //     const isConnected = await NetInfo.isConnected.fetch();
  //     if (!isConnected) {
  //       navigateTo('error', {
  //         message: 'No internet connection found',
  //         delay: 2000,
  //       });
  //     } else {
  //       navigateTo('error', {
  //         message: 'Something went wrong',
  //         delay: 2000,
  //       });
  //     }
  //   }
  // }
  // console.info('pricing:', respJson);
  // const {data = {}, meta_info = {}} = respJson;
  // const {reg = [], slot = [], recom = [], srecom = {}} = data;
  // const regWrap = reg === null ? [] : reg;
  // const slotWrap = slot === null ? [] : slot;
  // obj[hotelId] = {
  //   loaded: true,
  //   isLoggedIn: authId !== '',
  //   data: {
  //     reg: reg === null ? [] : reg,
  //     slot: slot === null ? [] : slot,
  //     recom: recom === null ? {} : recom,
  //     srecom: srecom === null ? {} : srecom,
  //     soldout: !reg.length && !slot.length,
  //     meta_info,
  //   },
  //   updatedAt: new Date().toString(),
  // };
  // if (sendGAData) {
  //   const {userId = ''} = user;
  //   const {spr = 0, adp = 0} = beforeLogin || {};
  //   const {rpl: new_rpl = []} = regWrap[0];
  //   const {pd: new_pd = {}} = new_rpl[0] || {};
  //   const {spr: new_spr = 0} = new_pd;
  //   const diff = spr - new_spr;
  //   adpGA({
  //     eventLabel: `Detail_${hotelId}_${spr}_${new_spr}_${adp}_${diff}_${userId}`,
  //     eventValue: diff,
  //   });
  // }
  // store.dispatch({
  //   type: UPDATE_HOTEL_PRICING_DATA,
  //   obj,
  // });

  // if (slotSelected) {
  //   const {styp = {}} = meta_info;
  //   if (Object.keys(styp).length && styp[stmg] && styp[stmg].length) {
  //     const slotRoomSelected = styp[stmg][0];
  //     store.dispatch({
  //       type: SLOT_ROOMSELECTED,
  //       slotRoomSelected,
  //       slotDetail: true
  //     });
  // if (slot === null && slotSelected) {
  //   Alert.alert('Goibibo', 'Selected Slot Hotel is not available', [{text: 'OK'}], {
  //     cancelable: false,
  //   });
  // }

  // const {sf = []} = meta_info;
  // if (slotSelected && sf.length) {
  //   let selectedFilter = [];
  //   sf.forEach(item => {
  //     if (item.min) {
  //       selectedFilter = [item.name];
  //     }
  //   });
  //   store.dispatch({
  //     type: UPDATE_PRICING_FILTER,
  //     pricingFilter: selectedFilter,
  //     slotSelected: true,
  //   });
  // }

  // pushGenericEvents({
  //   eventName: 'Hotel_AKB',
  //   eventDic: {
  //     hotel_has_akb: meta_info.flags && meta_info.flags.has_akb,
  //     minRatePlan_has_akb: meta_info.flags && meta_info.flags.is_min_akb,
  //   },
  // });
  // // console.info(store.getState());
  // // GA PUSH
  // if (regWrap.length === 0 && slotWrap.length === 0) {
  //   const {hn = ''} = selectedHotelStatic;
  //   const targetData = staticData[hotelId] || {};
  //   const hotelStaticData = targetData.data || {};
  //   // sold out inventory
  //   pushGenericEvents({
  //     eventName: 'Hotel_Sold_Out_Inventory',
  //     eventDic: {
  //       hotelCity: vcid,
  //       hotelName: hotelStaticData.hn || hn,
  //       HotelVoyagerID: hotelId,
  //       // cdHotelSearchCheckIn: ci,
  //       // cdHotelSearchCheckOut: co,
  //       cdHotelSearchPAX: roomString,
  //       cdIsGosuggest: 'false',
  //     },
  //   });
  // }
}
